<div class="match-list">
  @for (user of matches; track user.id) {
  <div
    class="match-item"
    [class.session-expired]="user.sessionExpired && !user.heartConfirmed"
    tabindex="0"
    role="button"
    (click)="openConversationWith(user)"
    (keyup.enter)="openConversationWith(user)"
    (keyup.space)="openConversationWith(user)"
  >
    <img
      [src]="user.imgUrl | versionedImageUrl : user.profileImageUpdatedAt"
      alt="avatar"
      class="avatar"
      [class.session-expired]="user.sessionExpired && !user.heartConfirmed"
      loading="lazy"
    />
    <div class="username">{{ user.userName }}</div>
  </div>
  }
</div>
